import {get} from "aws-amplify/api";
import {OrganizationViewModel} from "../viewModel/OrganizationView.model";
import {Responses} from "../type/StandardResponse";


export namespace OrganizationService {
    export async function findAllOrganizationsByCognitoId(): Promise<OrganizationViewModel[]> {
        const restOperation = get({
            apiName: 'API',
            path: '/organization'
        });
        const {body} = await restOperation.response;
        const result = Responses.fromDocumentType<OrganizationViewModel[]>(await body.json());
        if (result.error) {
            throw new Error(result.error.errorMessage);
        }
        return result.body;
    }
}

